// Clases de la app Gastos y Presupuestos (mismo lenguaje visual que Horas Trabajadas).
const inputBase = (isDarkMode: boolean) =>
  `rounded-lg border px-3 py-2 text-sm outline-none transition-colors ${
    isDarkMode
      ? "bg-[#232323] border-dark-border text-white focus:border-teal-500"
      : "bg-white border-gray-300 text-gray-900 focus:border-teal-500"
  }`;
export const ui = (isDarkMode: boolean) => ({
  text: isDarkMode ? "text-white" : "text-gray-900",
  muted: isDarkMode ? "text-gray-400" : "text-gray-500",
  border: isDarkMode ? "border-dark-border" : "border-gray-200",
  card: `rounded-2xl border p-4 ${isDarkMode ? "bg-dark-card border-dark-border" : "bg-white border-gray-200"}`,
  input: `w-full ${inputBase(isDarkMode)}`,
  /** Igual que `input` pero sin ancho: para combinar con `w-auto`, `w-24`… */
  inputBase: inputBase(isDarkMode),
  primary: "rounded-lg bg-teal-600 px-4 py-2 text-sm font-medium text-white hover:bg-teal-700 disabled:opacity-50",
  secondary: `rounded-lg border px-4 py-2 text-sm ${isDarkMode ? "border-dark-border text-gray-300 hover:bg-dark-surface" : "border-gray-300 text-gray-700 hover:bg-gray-50"}`,
  rowHover: isDarkMode ? "hover:bg-white/5" : "hover:bg-gray-50",
  surface: isDarkMode ? "bg-dark-surface" : "bg-gray-50",
});

export const INVOICE_TONES: Record<string, string> = {
  pendiente: "bg-amber-500/15 text-amber-600",
  adjunta: "bg-emerald-500/15 text-emerald-600",
  no_aplica: "bg-gray-400/15 text-gray-500",
  factura_extranjera: "bg-indigo-500/15 text-indigo-600",
};

export const INBOX_TONES: Record<string, string> = {
  adjuntada: "bg-emerald-500/15 text-emerald-600",
  creada: "bg-sky-500/15 text-sky-600",
  duplicada: "bg-gray-400/15 text-gray-500",
  sin_factura: "bg-gray-400/15 text-gray-500",
  error: "bg-red-500/15 text-red-600",
  por_confirmar: "bg-amber-500/15 text-amber-600",
};
